(() => {
  const initHeroVideo = (scope = document) => {
    scope.querySelectorAll('[data-v3-deferred-video]').forEach((video) => {
      if (video.dataset.v3Loaded === 'true') return;
      video.dataset.v3Loaded = 'true';

      if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;

      const loadVideo = () => {
        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });

        video.muted = true;
        video.defaultMuted = true;
        video.load();

        const reveal = () => video.classList.add('is-ready');
        video.addEventListener('playing', reveal, { once: true });
        video.addEventListener(
          'canplay',
          () => {
            const playPromise = video.play();
            if (playPromise?.catch) playPromise.catch(() => {});
          },
          { once: true }
        );
      };

      // Paint the poster first, then start loading the small optimized MP4 immediately.
      requestAnimationFrame(loadVideo);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initHeroVideo(), { once: true });
  } else {
    initHeroVideo();
  }

  document.addEventListener('shopify:section:load', (event) => initHeroVideo(event.target));
})();
